import React from 'react';
import Icon from '../../artzu-ui/src/Icon';

const DropdownHeader = ({ heading, theme }) => (
  <div className="contact-select-header">
    {heading}
    <Icon name="DownArrow" color="#128dff" size="xs" />
  </div>
);

export default DropdownHeader;



// WEBPACK FOOTER //
// ./src/components/NewContact/DropdownHeader.js